export var slotsSliceName = 'slots';
